module.exports = __webpack_public_path__ + "static/img/jfjt.1d98686.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/jfjt.svg
// module id = gJR2
// module chunks = 13